import { BRANDS_FORMATTED } from '../constants';
import type { Brand } from '../types/brand';

/**
 * Returns the formatted brand name for the given brand.
 *
 * @param brand The brand to format (zillow or hotpads).
 * @returns The formatted brand name for the given brand.
 */
export default (brand: Brand): string => BRANDS_FORMATTED[brand];
